import API from "./api";

export const createPayment = async (paymentData, token, deviseToken) => {
    const response = await API.post('/api/v1/payments/create',  paymentData, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Device-Token': deviseToken,
        },
    });
    return response.data;
}

// Кнопка «Отменить» на экране оплаты: переводит неоплаченный заказ в cancelled,
// иначе новый /create при живом Едином QR переиспользовал бы старый заказ
// и отказывал (409) при изменённых параметрах.
export const cancelPayment = async (orderId, provider, token, deviseToken) => {
    const response = await API.post('/api/v1/payments/cancel', { order_id: orderId, provider }, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Device-Token': deviseToken,
        },
    });
    return response.data;
}

export const getPriceApparat = async (deviseToken) => {
    const response = await API.get('/api/v1/payments/price', {
        headers: {
            'Device-Token': deviseToken,
        },
    });
    return response.data;
}

// Раньше киоск не имел ни одного способа узнать судьбу платежа сам — только
// косвенно, по началу печати (window.electronAPI.onPrintStatus). PaymentPage
// опрашивает этот эндпоинт, пока платёж не завершён.
export const getPaymentStatus = async (orderId, provider, token, deviseToken) => {
    const response = await API.get('/api/v1/payments/status', {
        params: { order_id: orderId, provider },
        headers: {
            Authorization: `Bearer ${token}`,
            'Device-Token': deviseToken,
        },
    });
    return response.data;
}

